<template>
  <select
    class="e-month-select"
    v-model="$parent[month]"
    @change="$emit('onSelectItem', $parent[month])"
  >
    <template v-if="monthOptions">
      <option
        v-if="placeholder"
        value=""
        v-bind:disabled="disablePlaceholderOption"
      >{{placeholder}}</option>
      <option
        v-for="option in monthOptions"
        :key="option.id"
        :value="option.id">{{option.name}}</option>
    </template>
  </select>
</template>

<script>
  import {month} from "../../utils/month"

  export default {
    name: 'e-select-month',
    props: {
      /**
       * Parent month name
       */
      month: {
        type: String,
        default: null,
        required: true
      },
      placeholder: {
        type: String,
        default: null
      },
      disablePlaceholderOption: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      monthOptions () {
        return month.getOptions()
      }
    }
  }
</script>
